/* Nightpass - liens "voir tout" et titres de categories */
(function () {
  function addLinks() {
    var wraps = document.querySelectorAll('.title-wrapper-with-link, .collection__title');
    for (var i = 0; i < wraps.length; i++) {
      var w = wraps[i];
      if (w.querySelector('.np-viewall')) continue;
      var root = w.parentElement;
      if (!root) continue;
      var href = null, label = null;
      if (root.querySelector('.collection-list')) {
        href = '/collections'; label = 'Voir toutes les catégories →';
      } else if (root.querySelector('.product-grid')) {
        href = '/search?q=*&type=product'; label = 'Voir tout le catalogue →';
      }
      if (!href) continue;
      w.classList.add('title-wrapper-with-link');
      var a = document.createElement('a');
      a.className = 'np-viewall';
      a.href = href;
      a.textContent = label;
      w.appendChild(a);
    }
  }

  function fixCollectionTitles() {
    var cards = document.querySelectorAll('.collection-list .card-wrapper');
    for (var i = 0; i < cards.length; i++) {
      var wrap = cards[i];
      if (wrap.querySelector('.np-cat-title-out')) continue;
      var card = wrap.querySelector('.card');
      if (!card) continue;
      var inner = card.querySelector('.card__inner');
      if (!inner) continue;
      var innerContent = inner.querySelector('.card__content');
      if (!innerContent) continue;
      var outerContent = card.querySelector(':scope > .card__content');
      if (outerContent && outerContent.textContent.trim().length) continue;
      var heading = innerContent.querySelector('.card__heading');
      if (!heading || !heading.textContent.trim().length) continue;
      var out = document.createElement('div');
      out.className = 'np-cat-title-out';
      out.appendChild(heading);
      card.appendChild(out);
      innerContent.style.display = 'none';
    }
  }

  function init() { addLinks(); fixCollectionTitles(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
